import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalSystemService } from '../local-system.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  email: string = "";
  error: boolean = false;
  success: boolean = false;
  errorMessage: string = "";

  constructor(private router: Router, public system: LocalSystemService) { }

  ngOnInit(): void {
  }

  requestPasswordReset() {
    if (!this.email || this.email.trim() === "") {
      this.error = true;
      this.errorMessage = "Моля, въведете имейл адрес";
      return;
    }

    this.error = false;
    this.success = false;
    this.system.ForgotPassword(this.email, this);
  }

  goToLogin() {
    this.router.navigate(['/']);
  }
}
